import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { Particles } from "./Particles";
import { whatsappLink } from "../data/content";

export const FinalCta = () => (
  <section data-testid="final-cta" className="noise-overlay relative overflow-hidden bg-navy-950 py-28 lg:py-36">
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1800&q=80"
        alt=""
        aria-hidden="true"
        className="h-full w-full object-cover opacity-40"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950/85 via-navy-950/55 to-navy-950/90" />
    </div>
    <Particles density={0.00004} />

    <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-8 lg:px-16">
      <Reveal>
        <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-gold-soft/90">The Next Step Is Yours</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 font-display text-3xl sm:text-5xl lg:text-6xl font-bold leading-[1.08] tracking-tight text-slate-50">
          Ready to transform your <span className="text-gold-metallic italic">UAE business?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400">
          One conversation is all it takes. Tell us where your business is — and where you want it
          to go. We'll show you exactly how to get there, with a free, no-pressure consultation.
        </p>
      </Reveal>
      <Reveal delay={0.26}>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#contact"
            data-testid="final-cta-consultation"
            className="btn-gold inline-flex items-center gap-2.5 rounded-full bg-gold px-9 py-4 text-sm sm:text-base font-semibold text-navy-950 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-[0_18px_50px_-10px_rgba(212,175,55,0.6)]"
          >
            Schedule Consultation Now
            <ArrowRight className="h-4 w-4" />
          </a>
          <a
            href={whatsappLink("Hello Faithh! I'd like to discuss how you can help my business.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            className="inline-flex items-center gap-2.5 rounded-full border border-gold/35 px-9 py-4 text-sm sm:text-base font-semibold text-gold-soft transition-[background-color,border-color,color] duration-400 hover:border-gold hover:bg-gold/10 hover:text-gold-bright"
          >
            <MessageCircle className="h-5 w-5" />
            Chat on WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
